
import spgecSVG from "../assets/images/SPGE_C.svg";
import spgecBlueSVG from "../assets/images/SPGE_C-blue.svg";
import FoundUserSVG from "../assets/images/found-user.svg";
import ThumbUpSVG from "../assets/images/thumb-up.svg";
import SearchSVG from "../assets/images/search.svg";
import Pass2SVG from "../assets/images/pass2.svg";
import LineRightSVG from "../assets/images/line_right.svg";
import StarSVG from "../assets/images/star.svg";
import ReloadSVG from "../assets/images/reload.svg";
import ReloadBlackSVG from "../assets/images/reload-black.svg";
import LineDownSVG from "../assets/images/line_down.svg";
import LineDownWhiteSVG from "../assets/images/line_down-white.svg"
import PencilSVG from "../assets/images/edit.svg";
import ClearSVG from "../assets/images/clear.svg";
import VisibleOnSVG from "../assets/images/visible-on.svg";
import VisibleOffSVG from "../assets/images/visible-off.svg";
import TrashSVG from "../assets/images/trash.svg";
import PlusBlueSVG from "../assets/images/plus-blue.svg";
import ToolTipsSVG from "../assets/images/tooltip.svg";
import PremiumIntroPNG from "../assets/images/premium_intro.png";
import InfoSVG from "../assets/images/information.svg";
import DotNormalSVG from "../assets/images/dot-normal.svg";
import DotFailureSVG from "../assets/images/dot-failure.svg";
import DotUnlinkedSVG from "../assets/images/dot-unlinked.svg";
import CalendarSVG from "../assets/images/calendar.svg";
import ThumbUpServiceSVG from "../assets/images/thumb-up-service.svg";
import ReviewServiceSVG from "../assets/images/review-service.svg";
import LineRightIconSVG from "../assets/images/line-right.svg";
import BeaminSVG from "../assets/images/beamin.svg";
import CoupangSVG from "../assets/images/coupang.svg";
import YogiyoSVG from "../assets/images/yogiyo.svg";
import PaymentSVG from "../assets/images/payment.svg";
import PremiumServiceSVG from "../assets/images/premium-service.svg";
import AlertSVG from "../assets/images/alert.svg";
import GreenProgressSVG from "../assets/images/green-progress.svg";
import LinkSVG from "../assets/images/link.svg";
import NoticeSVG from "../assets/images/notice.svg";
import ProgressSVG from "../assets/images/progress.svg";
import ReportSVG from "../assets/images/report.svg";
import LeftArrowSVG from "../assets/images/left-arrow.svg";
import LeftArrowDisabledSVG from "../assets/images/left-arrow-disabled.svg";
import RightArrowSVG from "../assets/images/right-arrow.svg";
import RightArrowDisabledSVG from "../assets/images/right-arrow-disabled.svg";
import BellSVG from "../assets/icons/bell.svg"
import BellBlueSVG from "../assets/icons/bell-blue.svg"
import PassSVG from "../assets/images/pass.svg";
import baeminLogoSVG from "../assets/images/logo-baemin.svg";
// import coupangLogoSVG from "../assets/images/logo-coupangeats.svg"; // logo nay bo goc bi meo
import coupangLogoSVG from "../assets/images/coupang.svg";
import yogiyoLogoSVG from "../assets/images/logo-yogiyo.svg";
import cautionSVG from "../assets/images/caution.svg";
import arrowRightSVG from "../assets/icons/arrow_right.svg";
import questionSVG from "../assets/icons/question.svg";
import FailedCommentsSVG from "../assets/icons/FailedComments.svg";
import PendingCommentsSVG from "../assets/icons/PendingComments.svg";
import SpecialReviewsSVG from "../assets/icons/SpecialReviews.svg";
import UnansweredReviewsSVG from "../assets/icons/UnansweredReviews.svg";
import noDataSVG from "../assets/images/no_data.svg";
import questionAlertSVG from "../assets/images/question-alert.svg";
import successAlertSVG from "../assets/images/success-alert.svg";
import errorAlertSVG from "../assets/images/warning.svg";
import informationAlertSVG from "../assets/images/information-alert.svg";
import shieldSVG from "../assets/images/shields.svg";
import homeNavSVG from "../assets/icons/home.svg";
import moreSVG from "../assets/icons/more.svg";
import dashboardSVG from "../assets/icons/dashboard.svg";
import reviewSVG from "../assets/icons/review.svg";
import comingSoonSVG from "../assets/images/coming_soon.svg";
import GeneralReviewsSVG from "../assets/images/general_reviews.svg";
import EditInfoSVG from "../assets/images/edit-info.svg";
import PremiumMoreSVG from "../assets/images/premium-more-page.svg";
import CardManageSVG from "../assets/images/card-manage.svg";
import AppConnectSVG from "../assets/images/app-connect-more-page.svg";
import ReviewSmallSVG from "../assets/images/review-more.svg";
import AnalyticsSmallSVG from "../assets/images/analytics-more-page.svg";
import OtherSmallSVG from "../assets/images/other-more-page.svg";
import ErrorSVG from "../assets/images/error.svg";
import NetworkIssueSVG from "../assets/images/network-issue.svg";
import NotFoundSVG from "../assets/images/not-found.svg";

export const AnalyticsSmallSvg = AnalyticsSmallSVG;
export const OtherSmallSvg = OtherSmallSVG;
export const ReviewSmallSvg = ReviewSmallSVG;
export const AppConnectSvg = AppConnectSVG;
export const CardManageSvg = CardManageSVG;
export const PremiumMoreSvg = PremiumMoreSVG;
export const EditInfoSvg = EditInfoSVG;
export const SpgecSvg = spgecSVG;
export const SpgecBlueSvg = spgecBlueSVG;
export const GeneralReviewsSvg = GeneralReviewsSVG;
export const ThumbUpSvg = ThumbUpSVG;
export const SearchSvg = SearchSVG;
export const Pass2Svg = Pass2SVG;
export const LineRightSvg = LineRightSVG;
export const StarSvg = StarSVG;
export const ReloadSvg = ReloadSVG;
export const VisibleOffSvg = VisibleOffSVG;
export const VisibleOnSvg = VisibleOnSVG;
export const FoundUserSvg = FoundUserSVG;
export const ReloadBlackSvg = ReloadBlackSVG;
export const LineDownSvg = LineDownSVG;
export const LineDownWhiteSvg = LineDownWhiteSVG;

export const PencilSvg = PencilSVG;
export const TrashSvg = TrashSVG;
export const ClearSvg = ClearSVG;
export const PlusBlueSvg = PlusBlueSVG;
export const ToolTipsSvg = ToolTipsSVG;
export const InfoSvg = InfoSVG;
export const DotNormalSvg = DotNormalSVG;
export const DotFailureSvg = DotFailureSVG;
export const DotUnlinkedSvg = DotUnlinkedSVG;
export const CalendarSvg = CalendarSVG;
export const ThumbUpServiceSvg = ThumbUpServiceSVG;
export const ReviewServiceSvg = ReviewServiceSVG;
export const LineRightIconSvg = LineRightIconSVG;
export const BeaminSvg = BeaminSVG;
export const CoupangSvg = CoupangSVG;
export const YogiyoSvg = YogiyoSVG;
export const PaymentSvg = PaymentSVG;
export const PremiumServiceSvg = PremiumServiceSVG;
export const AlertSvg = AlertSVG;
export const GreenProgressSvg = GreenProgressSVG;
export const LinkSvg = LinkSVG;
export const NoticeSvg = NoticeSVG;
export const ProgressSvg = ProgressSVG;
export const ReportSvg = ReportSVG;
export const LeftArrowSvg = LeftArrowSVG;
export const LeftArrowDisabledSvg = LeftArrowDisabledSVG;
export const RightArrowSvg = RightArrowSVG;
export const RightArrowDisabledSvg = RightArrowDisabledSVG;
export const ErrorSvg = ErrorSVG;
export const NotFoundSvg = NotFoundSVG;
export const NetworkIssueSvg = NetworkIssueSVG;
// Icons 
export const BellSvg = BellSVG;
export const BellBlueSvg = BellBlueSVG;
export const PassSvg = PassSVG;
export const baeminLogoSvg = baeminLogoSVG;
export const coupangLogoSvg = coupangLogoSVG;
export const yogiyoLogoSvg = yogiyoLogoSVG;
export const cautionSvg = cautionSVG;
export const arrowRightSvg = arrowRightSVG;
export const questionSvg = questionSVG;
export const FailedCommentsSvg = FailedCommentsSVG;
export const PendingCommentsSvg = PendingCommentsSVG;
export const SpecialReviewsSvg = SpecialReviewsSVG;
export const UnansweredReviewsSvg = UnansweredReviewsSVG;
export const noDataSvg = noDataSVG;
export const questionAlertSvg = questionAlertSVG;
export const successAlertSvg = successAlertSVG;
export const errorAlertSvg = errorAlertSVG;
export const informationAlertSvg = informationAlertSVG;
export const shieldSvg = shieldSVG;
export const homeNavSvg = homeNavSVG;
export const moreSvg = moreSVG;
export const dashboardSvg = dashboardSVG;
export const reviewSvg = reviewSVG;
export const comingSoonSvg = comingSoonSVG;
export const PremiumIntroPng = PremiumIntroPNG;





export {default as PremiumIntroReviewImagePNG} from "../assets/images/premium_intro_review_img.png";
export { default as PremiumIntroDemoPng } from "../assets/images/premium_intro_demo.png";
export { default as yogiyoLogoPng } from "../assets/images/logo-yogiyo2.png";








